<template>
  <div>
    <div class="liens">
      <br>
      <div class="columns">
        <div class="column is-12 is-paddingless">
          <my-vuetable />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyVuetable from './table/Table';

export default {
  name: 'LiensComponent',
  components: {
    MyVuetable
  }
};
</script>
<style scoped lang="scss">
    .global-info p {
        border-left-width: 4px;
        border-left-style: solid;
        padding-left: 1rem;
    }
</style>
